// extracted by mini-css-extract-plugin
module.exports = {"contextMenuContainer":"PurchasesVehicleListContextMenu_contextMenuContainer__BiMBV"};